'use client'

import { useContext } from 'react'
import { useInView } from 'react-intersection-observer'
import { ViewportTrackingContext } from '@/providers/ViewportTrackingProvider'

interface UseTrackingElementOptions {
  threshold?: number
  rootMargin?: string
  triggerOnce?: boolean
  onChange?: (visible: boolean) => void
}

export const useViewportTracking = (
  id: string,
  data?: Record<string, unknown>,
  options: UseTrackingElementOptions = {},
) => {
  const context = useContext(ViewportTrackingContext)

  const { ref, inView } = useInView({
    threshold: options.threshold ?? 0,
    rootMargin: options.rootMargin ?? '0px',
    triggerOnce: options.triggerOnce ?? true,
    onChange(visible) {
      if (visible) {
        context?.registerElement(id, data)
      }
      options.onChange?.(visible)
    },
    skip: !id,
  })

  return { ref, inView }
}
